<template>
  <div style="padding: 0 20px 20px 20px">
    <fieldset style="padding: 15px">
      <legend>稿件基本信息</legend>
      <h3 style="margin-bottom: 20px">{{ article.title }}</h3>
      <el-descriptions border>
        <el-descriptions-item label="作者">{{ article.authorName }}</el-descriptions-item>
        <el-descriptions-item label="投稿日期">{{ article.createTime | datefmt("YYYY-MM-DD HH:mm:ss") }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ article.contactTelephone }}</el-descriptions-item>
        <el-descriptions-item label="电子邮箱">{{ article.contactEmail }}</el-descriptions-item>
      </el-descriptions>
    </fieldset>
    <el-form ref="formData" :model="form" :rules="formRules" label-width="120px">
      <fieldset style="margin-top: 25px; padding: 15px">
        <legend>发票信息</legend>

        <el-form-item label="发票抬头" prop="companyName">
          <el-input v-model="form.companyName"></el-input>
        </el-form-item>

        <el-form-item label="开票税号" prop="regNumber">
          <el-input v-model="form.regNumber"></el-input>
        </el-form-item>

        <el-form-item label="开票金额" prop="money">
          <el-input v-model="article.issueCosted" :readonly="true"></el-input>
        </el-form-item>

        <el-form-item label="开票内容">
          <el-input v-model="content" :readonly="true" placeholder=""></el-input>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remarks" :readonly="false" type="textarea" placeholder="在这里填写信息给财务人员" rows="5"></el-input>
        </el-form-item>
      </fieldset>

      <fieldset style="margin-top: 25px; padding: 15px">
        <legend>电子发票传达途径信息</legend>
        <el-form-item label="邮箱地址" prop="email">
          <el-input v-model="form.email"></el-input>
        </el-form-item>
      </fieldset>

      <div style="margin-top: 25px">
        <el-button type="primary" @click="submit">确定无误，提交</el-button>
        <el-button type="default" @click="close">关闭</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import authorApi from "@/api/author"
import invoiceApi from "@/api/invoice"
export default {
  props: {
    articleId: {
      type: Number,
      require: false,
    },
  },

  data() {
    var validEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
      if (!value) {
        return callback(new Error("邮箱不能为空"))
      }
      if (mailReg.test(value)) {
        callback()
      } else {
        callback(new Error("请输入正确的邮箱格式"))
      }
    }
    return {
      article: {},
      content: "出版费",
      form: {
        articleId: 0,
        bankNumber: "", //银行账号
        companyAddress: "",
        companyName: "",
        companyPhone: "",
        email: "",
        einvoice: 2,
        openingBank: "",
        regNumber: "",
        remarks: "",
      },

      formRules: {
        companyName: [
          {
            required: true,
            min: 2,
            max: 50,
            message: "长度在 2 到 50个字符",
            trigger: "blur",
          },
        ],
        regNumber: [
          {
            required: true,
            min: 5,
            max: 20,
            message: "长度在 5 到 20个字符",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "必填",
            trigger: "blur",
          },
          { validator: validEmail, trigger: "blur" },
        ],
      },
    }
  },
  mounted() {
    this.loadArticle()
  },
  methods: {
    loadArticle() {
      authorApi.getArticleProcessList(this.articleId).then((res) => {
        if (res.code == 0) {
          this.article = res.article
          this.form.articleId = this.article.id
          this.form.email = this.article.email
        }
      })
    },

    submit() {
      this.$refs.formData.validate((valid) => {
        if (valid) {
          invoiceApi.add(this.form).then((res) => {
            if (res.code == 0) {
              this.drawer = false
              this.$notify({
                title: "成功",
                message: res.msg,
                type: "success",
              })
              this.submitSuccess()
            } else {
              this.$notify.error({
                title: "错误",
                message: res.msg,
              })
            }
          })
        }
      })
    },
    submitSuccess() {
      this.$emit("submitSuccess")
    },

    close() {
      this.$emit("close")
    },
  },
}
</script>
